import { render, staticRenderFns } from "./MaterialPrices.vue?vue&type=template&id=38108b27&scoped=true&"
import script from "./MaterialPrices.vue?vue&type=script&lang=js&"
export * from "./MaterialPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38108b27",
  null
  
)

export default component.exports